export const ERROR_CODES = {
  ERR_RANGE: 'ERR_RANGE',
  ERR_VALIDATION: 'ERR_VALIDATION',
  ERR_UNAUTHORIZED: 'ERR_UNAUTHORIZED',
  ERR_FORBIDDEN: 'ERR_FORBIDDEN',
  ERR_NOT_FOUND: 'ERR_NOT_FOUND',
  ERR_CONFLICT: 'ERR_CONFLICT',
  ERR_CAPACITY: 'ERR_CAPACITY',
  ERR_SURNAME_NOT_FOUND: 'ERR_SURNAME_NOT_FOUND',
  // Roster: the name still has hut-duty slots, which a delete would cascade
  // away (migration 0002). Refused unless the caller opts in explicitly.
  ERR_NAME_HAS_DUTY_SLOTS: 'ERR_NAME_HAS_DUTY_SLOTS',
  ERR_RATE_LIMIT: 'ERR_RATE_LIMIT',
  // Poll: the poll is not accepting changes (draft, closed, past deadline, or finalized).
  ERR_POLL_CLOSED: 'ERR_POLL_CLOSED',
  // Poll: the slot is locked or closed and cannot be claimed.
  ERR_SLOT_LOCKED: 'ERR_SLOT_LOCKED',
  // Email: the Gmail service-account settings are absent, so sending is off.
  ERR_EMAIL_NOT_CONFIGURED: 'ERR_EMAIL_NOT_CONFIGURED',
  // Email: configured, but the send failed upstream (auth, quota, network).
  ERR_EMAIL_SEND: 'ERR_EMAIL_SEND',
  ERR_INTERNAL: 'ERR_INTERNAL',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export type ApiError = {
  error: {
    code: ErrorCode;
    message?: string;
    details?: unknown;
  };
};

export function apiError(code: ErrorCode, message?: string, details?: unknown): ApiError {
  return { error: { code, message, details } };
}
